import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/react';

export function useFloatingModal(isOpen: boolean) {
    return useFloating({
        open: isOpen,
        // The initial desired placement.
        placement: 'right-start',
        // The middleware will automatically run to keep the modal on screen.
        middleware: [
            // Adds an 8px gap between the trigger and the modal.
            offset(8),
            // Flips the modal to the opposite side if it runs out of space.
            flip({ fallbackAxisSideDirection: 'start', padding: 8 }),
            // Shifts the modal to prevent it from being clipped by the edges of the viewport.
            shift({ padding: 8, crossAxis: true }),
        ],
        // This automatically updates the modal's position when the user scrolls
        // or resizes the window.
        whileElementsMounted: autoUpdate,
    });
}
